import React, { useState } from 'react';
import { Card, Grid, Modal, Stack, Title } from 'library/ui';
import { BusinessSlot } from 'models';
import { BusinessJobShiftSlot } from '../BusinessJob/components/BusinessJobShiftSlot';
import { ApplicantApprovalSummary } from './BusinessCalendar';
import { addDays, isWithinInterval, startOfDay } from 'date-fns';
import UnfilledShiftsWithApprovals from './UnfilledShiftsWithApprovals';
import styled from '@mui/material/styles/styled';
import { Colors } from 'library/theme';
export default function UnfilledShifts({
    slots,
    title,
    refresh,
    approvals,
}: {
    slots: BusinessSlot[];
    title: string;
    refresh: () => void;
    approvals: ApplicantApprovalSummary[];
}) {
    const [viewShifts, setViewShifts] = useState(false);
    const unfilledShifts = slots.reduce((unfilledJobsWithSlots: { [key: string]: number }, slot: BusinessSlot) => {
        const job = slot.ongoing_request.id.toString();
        unfilledJobsWithSlots[job] = unfilledJobsWithSlots[job] || 0;
        unfilledJobsWithSlots[job] =
            slot.appointments.length === 0
                ? unfilledJobsWithSlots[job] + 1
                : unfilledJobsWithSlots[job] + slot.appointments.filter((appt) => appt.providers.length === 0).length;

        return unfilledJobsWithSlots;
    }, {});
    const date = new Date(slots[0].start_date);
    const today = startOfDay(new Date());
    const startsWithin3Days = isWithinInterval(date, { start: today, end: addDays(today, 3) });
    const unfilledShiftsWithApprovals = Object.entries(unfilledShifts).filter(
        (x) =>
            startsWithin3Days &&
            approvals.some((approval) => approval.job.toString() === x[0] && approval.applicants.length > 0),
    );
    const unfilledShiftsWithoutApprovals = Object.entries(unfilledShifts).filter(
        (x) =>
            !startsWithin3Days ||
            !approvals.some((approval) => approval.job.toString() === x[0] && approval.applicants.length > 0),
    );
    const totalUnfilledWithoutApprovals = unfilledShiftsWithoutApprovals.reduce((acc, [, count]) => acc + count, 0);

    return (
        <Stack gap="sm" align="center">
            {unfilledShiftsWithApprovals.map(([jobId, count]) => (
                <UnfilledShiftsWithApprovals
                    key={jobId}
                    jobId={jobId}
                    count={count}
                    slot={slots.find((slot) => slot.ongoing_request.id.toString() === jobId)}
                    approvalsForJob={approvals.find(
                        (approval) => approval.job.toString() === jobId && approval.applicants.length > 0,
                    )}
                    onViewShifts={() => setViewShifts(true)}
                />
            ))}
            {totalUnfilledWithoutApprovals > 0 && (
                <UnfilledShiftsCard interactive onClick={() => setViewShifts(true)} padding="xs">
                    {totalUnfilledWithoutApprovals} unfilled shift
                    {totalUnfilledWithoutApprovals === 1 ? '' : 's'}
                </UnfilledShiftsCard>
            )}
            {viewShifts && (
                <Modal onClose={() => setViewShifts(false)} width={720}>
                    <Stack gap="lg">
                        <Title size="h1">{`Unfilled shifts for ${title}`}</Title>
                        <Grid minColumnWidth={280} gap="md">
                            {slots.map((slot) => (
                                <BusinessJobShiftSlot
                                    key={slot.id}
                                    slot={slot}
                                    job={slot.ongoing_request}
                                    getJob={refresh}
                                />
                            ))}
                        </Grid>
                    </Stack>
                </Modal>
            )}
        </Stack>
    );
}

const UnfilledShiftsCard = styled(Card)({
    border: `2px dashed ${Colors.border}`,
});
